//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import SubscriptionTypeUpgrade from 'src/components/SubscriptionTypeUpgrade';
export default {
  components: {
    SubscriptionTypeUpgrade: SubscriptionTypeUpgrade
  },
  props: {
    value: {
      type: String
    },
    dense: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      internalValue: this.value
    };
  },
  watch: {
    internalValue: function internalValue(val) {
      this.$emit('input', val);
    }
  },
  methods: {
    eventsMap: function eventsMap(itemEvents) {
      delete itemEvents.click;
      return itemEvents;
    },
    updateAccessLevel: function updateAccessLevel(accessLevel) {
      if (!this.me.account.hasFeatureAccess('access_levels') && this.$refs["access-level-".concat(accessLevel)]) {
        this.$refs["access-level-".concat(accessLevel)].showTooltip();
        return;
      }

      this.internalValue = accessLevel;
    }
  }
};